import { useCallback } from "react";
import useSWRMutation from "swr/mutation";
import type { DirectUploadedFile } from "~/models/DealForm";
import type {
	DirectUploadAttachmentType,
	UploadFileArg
} from "~/utils/api/DirectUploadFile";
import { uploadFile } from "~/utils/api/DirectUploadFile";

export const useDirectUploadFile = (
	mutationKeyId: string
): {
	isUploading: boolean;
	upload: (
		file: File,
		attachmentType: DirectUploadAttachmentType
	) => Promise<DirectUploadedFile>;
} => {
	const { trigger, isMutating } = useSWRMutation(
		`/direct_upload_files/${mutationKeyId}`,
		(_key: string, { arg }: { arg: UploadFileArg }) => uploadFile(arg)
	);

	const upload = useCallback(
		(
			file: File,
			attachmentType: DirectUploadAttachmentType
		): Promise<DirectUploadedFile> => trigger({ attachmentType, file }),
		[trigger]
	);

	return { isUploading: isMutating, upload };
};
